import { Component, ElementRef, OnInit, ViewChild, HostBinding } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { v4 as uuidv4 } from 'uuid';
import { Router } from '@angular/router';
import { MessageSeverity } from '../../../enums/message-severity';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { SettingsService } from '../../../services/settings/settings.service';
import { environment } from '../../../../environments/environment';
import { TelemetorComponent } from '../../base/telemetor/telemetor.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent extends TelemetorComponent implements OnInit {

    public subdomain: string = "";

    @HostBinding("class.component-flex-vertical-fill") addClass = true;

    public credentials: any = { UserUID: "admin.primary", Password: "abc123" };

    @ViewChild("googleButtonDiv", { read: ElementRef }) googleButtonDiv: ElementRef | undefined;

    public constructor(public appService: AppService,
                       public authService: AuthService,
                       public settingsService: SettingsService,
                       public router: Router,
                       public http: HttpClient) {
        super();
    }

    public override ngOnInit(): void {

        const hostname: string = window.location.hostname;
        const parts = hostname.split('.');

        if (parts.length > 1) {

            this.subdomain = parts[0];
        }

        this.emitTelemetrigram("load");
    }

    public ngAfterViewInit(): void { }

    public loginGoogle = (): void => {

        const googleClientId = environment.authentication.google.clientId;
        const fqdn = `${this.subdomain}.${environment.registeredDomain}`;
        const redirectUri = environment.authentication.google.redirectUri.replace('{FQDN}', fqdn);
        const redirectUriEncoded = encodeURIComponent(redirectUri);

        const isBaseScopeAuthFlow: boolean = true; // omit people api and contact harvesting

        let scope: string;

        if (isBaseScopeAuthFlow) {

            scope = encodeURIComponent([
                "https://www.googleapis.com/auth/userinfo.profile",
                "https://www.googleapis.com/auth/userinfo.email"
            ].join(" "));

        } else {

            scope = encodeURIComponent([
                "https://www.googleapis.com/auth/userinfo.profile",
                "https://www.googleapis.com/auth/userinfo.email",
                "https://www.googleapis.com/auth/contacts.readonly"
            ].join(" "));
        }

        const url = `https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=${googleClientId}` + `&redirect_uri=${redirectUriEncoded}&scope=${scope}&access_type=offline&prompt=consent`;

        window.location.href = url;
    };

    public loginInstagram = (): void => {

        var instagramAppId: string = environment.authentication.instagram.AppId;
        var fqdn: string = this.subdomain + "." + environment.registeredDomain;
        var redirectUri: string = environment.authentication.instagram.redirectUri.replace("{FQDN}", fqdn);
        var redirectUriEncoded: string = encodeURIComponent(redirectUri);

        var url = "https://api.instagram.com/oauth/authorize?" + "client_id=" + instagramAppId + "&" + 
                                                                 "redirect_uri=" + redirectUriEncoded + "&" + 
                                                                 "scope=user_profile,user_media&" +
                                                                 "response_type=code";

        window.location.href = url;
    }
}
